import { baseUrls } from './baseUrls.utils';

export const getArticleLink = (id: string): string =>
    `${baseUrls.browse.main}/article/${id}`;
export const getUserGuideArticleLink = (id: string): string =>
    `${baseUrls.userGuides}/article/${id}`;
export const getChannelLink = (id: string): string =>
    `${baseUrls.browse.main}/channel/${id}`;
export const getDeskLink = (id: string): string =>
    `${baseUrls.desk.main}/${id}`;
export const getChannelSubscriptionLink = (id: string) =>
    baseUrls.channelSubscription.replace(':channelId', id);
export const getChannelSubscriptionConfirmationLink = (id: string) =>
    baseUrls.channelSubscriptionPayment.replace(':channelId', id);
export const getChannelSubscriptionTrialConfirmLink = (id: string) =>
    baseUrls.channelSubscriptionConfirmTrial.replace(':channelId', id);
export const getChannelSubscriptionInterestConfirmLink = (id: string) =>
    baseUrls.channelSubscriptionConfirmInterest.replace(':channelId', id);
